import { atom } from "jotai";

// none, org_1, org_2, org_3
export const showcaseTypeAtom = atom("none");

export const showcaseOrgAtom = atom({})

export const showcaseAtom = atom((get) => {
    const type = get(showcaseTypeAtom);
    const org = get(showcaseOrgAtom);
    return { type, org }
})